<template>
  <div id="UnitOwnerList_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            出席名單
          </div>
        </div>
      </div>
      <RegisterList
        :show-filter="true"
        :show-conrtol-wrap="true"
        :show-button="false"
        :display-mode="1"
        :show-registration="true"
      />
    </div>
  </div>
</template>
<script>
import RegisterList from '../UnitOwnerAssembly/components/RegisterList'

export default {
  components: {
    RegisterList
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="sass" scoped>
#UnitOwnerList_main
  +mainLayer
</style>
